import { render } from "./icon-calendar.svg?vue&type=template&id=9ea3cf70&scoped=true&component"
const script = {}

import "./icon-calendar.svg?vue&type=style&index=0&id=9ea3cf70&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ea3cf70"]])

export default __exports__